module.exports = __webpack_public_path__ + "static/img/rpaBlanco.0f3e7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rpaBlanco.jpg
// module id = wtEP
// module chunks = 9